exports.components = {
  "component---src-pages-index-js": () => import("./../../../src/pages/index.js" /* webpackChunkName: "component---src-pages-index-js" */),
  "component---src-pages-kontakt-js": () => import("./../../../src/pages/kontakt.js" /* webpackChunkName: "component---src-pages-kontakt-js" */),
  "component---src-pages-nase-prace-js": () => import("./../../../src/pages/nase-prace.js" /* webpackChunkName: "component---src-pages-nase-prace-js" */)
}

